import { Component } from 'react'
import { Col, Row, Input } from 'reactstrap'
import AdvancedFiltersControl from '../Filters/AdvancedFiltersControl'
import AppliedAdvancedFilters from '../Filters/AppliedAdvancedFilters'

class SubrogationClaimListHeader extends Component {
    updateSearchTerm = (searchTerm) => {
        this.props.setFilterValues({ ...this.props.filterValues, searchTerm })
    }

    render() {
        return (
            <Row className="pb-2">
                <Col xs={12} className="mt-2">
                    <Row className="align-items-center">
                        <Col>
                            <span className="driver-search-filter">
                                <Input
                                    type="text"
                                    name="searchTerm"
                                    placeholder="Search"
                                    onChange={(e) => this.updateSearchTerm(e.target.value)}
                                />
                                <i className="fa fa-lg fa-search search-icon" aria-hidden="true"></i>
                            </span>
                        </Col>
                        <Col className="p-0">
                            <AdvancedFiltersControl
                                entity="subrogation_claim"
                                presets={this.props.presets}
                                setPresets={this.props.setPresets}
                                defaultPresets={this.props.defaultPresets}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col xs={12} className="mt-2 search-filter-container">
                    <AppliedAdvancedFilters
                        entity="subrogation_claim"
                        context={null}
                        presets={this.props.presets}
                        onPresetsChange={this.props.setPresets}
                    />
                </Col>
            </Row>
        )
    }
}

export default SubrogationClaimListHeader
